export const selectedBorerIdKey = 'SELECTED_BORER_ID_KEY';
